<!-- 运营大屏 -->
<template>
  <div class="body" :style="{ height: layoutPageHeight + 'px' }">
    <div class="d-flex between">
      <el-select
        class="input200"
        v-model="userCountry"
        :placeholder="`国家`"
        @change="getData"
        :disabled="user.role_id !== 1"
        >
        <el-option
          v-for="item in countries"
          :key="item.code"
          :label="item.name"
          :value="item.code">
        </el-option>
      </el-select>
      <div class="row1">
        <div class="row1-item" v-for="(item, index) in eachNumberStatistics" :key="index">
          <div>{{ item.value }}</div>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="row2">
      <div class="row2-1" id="mapEcharts"></div>
      <div class="row2-1" id="barChart1"></div>
    </div>
    <div class="row2">
        <div ref="pieChart1" class="pieChart" id="pieChart1"></div>
        <div ref="pieChart2" class="pieChart" id="pieChart2"></div>
        <div class="row2-1" ref="lineChart" id="lineChart"></div>
    </div>
  </div>
</template>

<script>
// import 'echarts/lib/chart/pie'; // 引入饼图
import axios from 'axios'
import { mapGetters } from 'vuex';
import store from '@/store';
import 'echarts/extension/bmap/bmap';
import { apiLangKey, countryMap, symbolPath } from '@/utils/Config';
const langKey = localStorage.getItem(apiLangKey) || 'zh_CN'
import { largScreEachNumSta, largScreTenaStat, printTendencyStatistics, tenantPrintStatistics } from '@/api.js';
export default {
  data() {
    return {
      eachNumberStatistics: [],
      layoutPageHeight: 0,
      existingColors: [],
      userCountry: ''
    };
  },
  computed: {
    ...mapGetters(['user', 'countries']),
  },
  mounted() {
    store.dispatch('setCountries');
    this.initUserCountry();
    this.getData();

    // 获取样式为layout-page的第一个元素的高度
    this.layoutPageHeight = document.querySelector('.layout-page').offsetHeight - 30;
    window.addEventListener('resize', function () {
      window.location.reload();
    });
  },
  methods: {
    initUserCountry() {
      this.userCountry = this.user.country || 'CN'
    },
    // 获取页面数据
    getData() {
      // 获取统计数量，实时统计
      this.$request('get', largScreEachNumSta, { country: this.userCountry }).then((res) => {
        if (res) {
          this.eachNumberStatistics = [
            {
              value: res.tenant_number,
              name: `全部租户数量`,
            },
            {
              value: res.user_number,
              name: `用户数量`,
            },
            {
              value: res.printer_active_number,
              name: `租户打印机激活数量`,
            },
            {
              value: res.honjo_printer_active_number,
              name: `内部打印机激活数量`,
            },
            {
              value: res.print_number,
              name: `标签打印数量`,
            },
          ];
        }
      });

      this.$request('get', largScreTenaStat, { country: this.userCountry }).then((res) => {
        if (res) {
          //租户类型
          let tenantType = [];
          for (let i = 0; i < res.scale_tenant.length; i++) {
            let item = res.scale_tenant[i];
            tenantType.push({
              value: item.number,
              name: item.name,
            });
          }
          this.initPieChart1(tenantType);

          // 租户规模
          let tenantSize = [];
          for (let i = 0; i < res.average_instrumentset_tenant.length; i++) {
            let item = res.average_instrumentset_tenant[i];
            tenantSize.push({
              value: item.number,
              name: item.name,
            });
          }
          this.initPieChart2(tenantSize);

          // 租户分布
          let tenantDistribution = [];
          for (let i = 0; i < res.city_tenant.length; i++) {
            let item = res.city_tenant[i];
            tenantDistribution.push({
              name: item.name,
              value: [item.longitude, item.latitude, item.number],
            });
          }
          this.initMap(tenantDistribution);
        }
      });

      // 获取折线图数据
      this.$request('get', printTendencyStatistics, { country: this.userCountry }).then((res) => {
        if (res) {
          let data = { time: [], value: [] };
          for (let i = 0; i < res.length; i++) {
            let item = res[i];
            data.time.push(item.date);
            data.value.push(item.number);
          }
          this.initLineChart(data);
        }
      });

      // 租户打印统计
      this.$request('get', tenantPrintStatistics, { country: this.userCountry }).then((res) => {
        if (res) {
          let data = {
            yAxisData: [],
            seriesData: [],
          };
          res.forEach((item) => {
            data.yAxisData.push(item.name);
            data.seriesData.push(item.number);
          });
          this.initBarChart1(data);
        }
      });
    },
    // 柱状图
    initBarChart1(data) {
      let option = {
        title: {
          text: `按租户统计 - 标签打印统计`,
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        // legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
          data: data.yAxisData,
        },
        series: [
          {
            name: '2011',
            type: 'bar',
            data: data.seriesData,
          },
        ],
      };
      this.createMap('barChart1', option);
    },
    // 创建echarts表格 的公共函数
    createMap(eleId, option) {
      var myChart = this.$echarts.getInstanceByDom(document.getElementById(eleId));

      if (myChart) {
        // 图表实例存在，执行更新操作
        myChart.setOption(option);
      } else {
        // 图表实例不存在，执行创建操作
        myChart = this.$echarts.init(document.getElementById(eleId));
        myChart.setOption(option);
      }
    },
    initLineChart(data) {
      const option = {
        title: {
          text: `标签打印总量日趋势`,
          left: 'center',
        },
        grid: {
          left: '10', // 左边距
          right: '10', // 右边距
          top: '40', // 顶部边距
          bottom: '10', // 底部边距
          containLabel: true, // 包含坐标轴标签在内
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.time,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: data.value,
            type: 'line',
            smooth: true,
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置
            },
          },
        ],
      };
      this.createMap('lineChart', option);
    },
    initMap(data) {
      let newData = [];
      data.forEach((item) => {
        newData.push({
          name: item.name,
          value: item.value,
          quantity: item.value[2],
          unit: `家`,
        });
      });
      this.createChinaMap(newData);
    },

    fetchMapData() {
      // 读取地图数据
      const countryKey =  countryMap[this.userCountry]['name'] || 'china'
      const mapJsonPath = `${window.location.origin}${this.$utils.siteBase()}static/maps/${countryKey}_${langKey}.json`

      return axios.get(mapJsonPath)
      .then(res => res && res.data)
    },

    async createChinaMap(data) {
      const mapJson = await this.fetchMapData();
      this.$echarts.registerMap('map', mapJson);
      let myChart = this.$echarts.init(document.getElementById('mapEcharts'));

      let option = {
        myChart: myChart,
        warehouseList: data,
        title: `租户地域分布图`,
      };
      this.setOption(option);
    },
    /**
     * option = {
     *  myChart: echarts对象 必须
     *  warehouseList: 仓库信息
     *  highlightAreaList： 需要高亮的省
     *  center： 地图初始中心
     * }
     */
    setOption(option) {
      const countryCenter = countryMap[this.userCountry]['center']
      option.myChart.setOption({
        title: {
          text: option.title,
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.name;
          },
        },
        geo: {
          // 指定区域设置样式和
          center: countryCenter,
          map: 'map',
          // silent: false,
          // regions: this.randomColorFun(),
          zoom: 1, //缩放
          roam: true, //鼠标可拖动、缩放
          emphasis: {
            itemStyle: {
              areaColor: 'rgb(84,112,198)', // 鼠标悬停时区域的颜色
            },
          },
        },
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            data: option.warehouseList,
            symbolSize: function (data) {
              return [(data[2] + 10) * 0.7, data[2] + 10];
            },
            symbol: 'path://' + symbolPath,
            itemStyle: {
              color: 'rgb(253,144,20)',
            },
            tooltip: {
              formatter: function (params) {
                return params.name + ' ' + params.data.quantity + params.data.unit;
              },
            },
          },
        ],
      });
    },

    // 租户类型
    initPieChart1(data) {
      const option = {
        title: {
          text: `租户类型`,
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '30',
          textStyle: {
            fontSize: 10,
          },
        },
        series: [
          {
            name: `租户类型`,
            center: ['50%', '65%'], // 设置饼图的中心位置
            type: 'pie',
            // radius: '50%',
            radius: ['0%', '60%'],
            data: data,
            label: {
              show: true,
              position: 'inside',
              formatter: '{d}%',
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      this.createMap('pieChart1', option);
    },

    // 租户规模
    initPieChart2(data) {
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: `租户规模(日均处理)`,
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: '30',
          textStyle: {
            fontSize: 10,
          },
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        //   top: '50',
        // },
        series: [
          {
            name: `租户规模`,
            center: ['50%', '65%'], // 设置饼图的中心位置
            type: 'pie',
            // radius: '50%',
            radius: ['0%', '60%'],
            data: data,
            label: {
              show: true,
              position: 'inside',
              formatter: '{d}%',
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      this.createMap('pieChart2', option);
    },
  },
};
</script>

<style scoped lang="scss">
.body {
  background: #fff;
  padding: 20px;
  min-height: 710px;
}
.row1 {
  height: 10%;
  min-height: 70px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.row1-item {
  width: 200px;
  background: #fff;
  padding: 10px 0px;
  border: 1px solid #666;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.row2 {
  display: flex;
  height: 45%;
  // min-height: 450px;
}
.pieChart {
  width: 25%;
  height: 100%;
}
.row2-1 {
  width: 50%;
}
</style>
